// Human-readable mappings for Paytm transaction-status responses, so codes like
// "601" aren't shown raw to the user.

// Friendly labels for the fields Paytm returns in the status body.
export const FIELD_LABELS = {
  orderId: "Order ID",
  txnId: "Transaction ID",
  bankTxnId: "Bank Transaction ID",
  txnAmount: "Amount",
  txnType: "Transaction Type",
  gatewayName: "Gateway",
  bankName: "Bank",
  mid: "Merchant ID",
  paymentMode: "Payment Mode",
  refundAmt: "Refund Amount",
  txnDate: "Transaction Date",
  resultStatus: "Status",
  resultMsg: "Message",
};

// Order in which to show fields in the readable view.
export const FIELD_ORDER = [
  "orderId",
  "txnId",
  "bankTxnId",
  "txnAmount",
  "refundAmt",
  "paymentMode",
  "bankName",
  "txnType",
  "txnDate",
  "mid",
];

// Map a Paytm resultStatus to a friendly label + MUI color.
export const resultStatusInfo = (resultStatus) => {
  const s = `${resultStatus || ""}`.toUpperCase();
  if (s === "TXN_SUCCESS" || s === "SUCCESS") return { label: "Success", color: "success" };
  if (s === "PENDING") return { label: "Pending", color: "warning" };
  if (s === "TXN_FAILURE" || s === "FAILURE") return { label: "Failed", color: "error" };
  return { label: resultStatus || "Unknown", color: "default" };
};

// Common Paytm result/refund codes → readable text (falls back to the raw value).
const CODE_LABELS = {
  "01": "Success",
  10: "Success",
  TXN_SUCCESS: "Success",
  SUCCESS: "Success",
  601: "Pending / In process",
  402: "Pending",
  PENDING: "Pending",
  501: "Failed",
  TXN_FAILURE: "Failed",
  FAILURE: "Failed",
  REFUND_FAILURE: "Failed",
};

// Friendly text for a refund status/code (e.g. "601" → "Pending / In process").
export const refundStatusLabel = (value) => {
  if (value === null || value === undefined || `${value}`.trim() === "") return null;
  const key = `${value}`.trim().toUpperCase();
  return CODE_LABELS[key] || CODE_LABELS[`${value}`.trim()] || `${value}`;
};

// Format an amount with currency.
export const formatAmount = (value, currency = "INR") => {
  if (value === null || value === undefined || `${value}` === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return `${value}`;
  return `${num.toFixed(2)} ${currency}`.trim();
};
